import { render, staticRenderFns } from "./CompensationDetailsMenu.vue?vue&type=template&id=4a2d63c8"
import script from "./CompensationDetailsMenu.vue?vue&type=script&lang=js"
export * from "./CompensationDetailsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports